'use client';

export { default } from './TableCell';
export { default as tableCellClasses } from './tableCellClasses';
export * from './tableCellClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/TableCell/index.js
// module id = 593
// module chunks = 25